export default function EmailIcon() {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_126_5076)">
        <path
          d="M1.1932 0.178866L6.75252 6.83985C7.07116 7.21904 7.5254 7.43368 7.99997 7.43368C8.47455 7.43368 8.93557 7.21904 9.24743 6.83985L14.7186 0.293341C14.7661 0.236103 14.8203 0.20033 14.8746 0.164557C14.644 0.0572372 14.3864 0 14.122 0H1.8915C1.63387 0 1.38981 0.0572372 1.16608 0.150248C1.17286 0.157402 1.18642 0.164557 1.1932 0.178866Z"
          fill="white"
        />
        <path
          d="M15.7153 0.9375C15.6881 1.00189 15.6542 1.07344 15.6068 1.13068L10.1424 7.67003C9.6 8.3211 8.82034 8.69314 8 8.69314C7.17966 8.69314 6.4 8.3211 5.85763 7.67003L0.298305 1.00905C0.298305 1.00905 0.277966 0.980428 0.271186 0.966119C0.101695 1.26661 0 1.61719 0 1.99639V11.0112C0 12.1131 0.847458 13.0074 1.89153 13.0074H14.1153C15.1593 13.0074 16.0068 12.1131 16.0068 11.0112V1.99639C16.0068 1.61004 15.8983 1.24515 15.7153 0.9375Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_126_5076">
          <rect width="16" height="13" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
